/**
 * Platform-wide constants: tier limits, feature flags, defaults.
 */

export const PLATFORMS = [
  "instagram",
  "tiktok",
  "youtube",
  "linkedin",
  "twitter",
  "threads",
] as const;
export type Platform = (typeof PLATFORMS)[number];

export const SUPPORTED_LANGUAGES = ["en", "ar", "fr", "de", "es"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

export const TIER_LIMITS = {
  free: { posts: 10, workspaces: 1 },
  starter: { posts: 100, workspaces: 1 },
  pro: { posts: 1000, workspaces: 5 },
  scale: { posts: 10000, workspaces: 25 },
} as const;
export type Tier = keyof typeof TIER_LIMITS;
